import { observer } from 'mobx-react';
import { FC } from 'react';
import DineInPaymentMethods from '../../containers/DineInPaymentMethods/DineInPaymentMethods';
import DineInSections from '../../containers/DineInSections/DineInSections';
import QrCode from '../../containers/QrCode/QrCode';
import branchEditStore from '../../store/branchEditStore';
import { localeStore } from 'src/mobx/localesStore';
import { appStore } from 'src/mobx/appStore';

const BranchDineIn: FC = observer((): JSX.Element => {
  const hasBranchQr = branchEditStore.editableBranch.emenu?.qr !== undefined;

  if (!appStore.settings?.is_emenu) {
    return (
      <div className="d-flex flex-1 align-items-center justify-content-center">
        <p className="family-medium text-size-16 color-gray2">{localeStore.t('turn_on_emenu_to_configure_dinein')}</p>
      </div>
    );
  }

  return (
    <div className={`d-flex flex-1 gap-50 ${hasBranchQr ? 'justify-content-between' : 'justify-content-start'}`}>
      {hasBranchQr && <QrCode />}
      <DineInPaymentMethods />
      <DineInSections />
    </div>
  );
});

export default BranchDineIn;
